import { gql } from "@apollo/client"

export const CREATE_SCHOOL_ADMIN = gql`
  mutation createSchoolAdmin($data: CreateSchoolAdminRequest!) {
    schoolAdmin {
      create(data: $data)
    }
  }
`

export const UPDATE_SCHOOL_ADMIN = gql`
  mutation updateSchoolAdmin($data: UpdateSchoolAdminRequest!) {
    schoolAdmin {
      update(data: $data)
    }
  }
`

export const DELETE_SCHOOL_ADMINS = gql`
  mutation deleteSchoolAdmins($data: SchoolAdminsIdsListRequest) {
    schoolAdmin {
      removeBatch(data: $data)
    }
  }
`

export const SCHOOL_ADMIN_SAVE_ONBOARDING = gql`
  mutation saveOnboarding($data: SchoolAdminOnboardingSaveRequest!) {
    schoolAdmin {
      saveOnboarding(data: $data)
    }
  }
`
